import $ from 'jquery';
import debounce from 'lodash/debounce';
import {getFromTemplate, renderItem, scrollWithOffset, triggerEvent} from '../base/utils';

class ViewLoader {
    constructor($list, $moreBtn, perPage, offset, templates, getters, onResize) {
        this.$list = $list;
        this.$moreBtn = $moreBtn;
        this.perPage = perPage;
        this.initial = offset || 0;

        this.getUrl = getters.getUrl;
        this.getPaginationUrl = getters.getPaginationUrl;

        this.itemTemplate = templates.itemTemplate;
        this.emptyTemplate = templates.emptyTemplate;
        this.errorTemplate = templates.errorTemplate;

        if (onResize && typeof onResize === 'function') {
            window.addEventListener('resize', debounce(onResize.bind(this), 100));
        }

        this.init();
    }

    async init() {
        this.total = await this.getTotal();
        this.current = this.initial;
        this.handleMoreBtn();
        this.get(false, false);
    }

    setPerPage(perPage) {
        this.perPage = perPage;
    }

    displayMoreBtn() {
        if (this.total < this.perPage) {
            this.$moreBtn.style.display = 'none';
        } else {
            this.$moreBtn.style.display = '';
        }
    }

    handleMoreBtn() {
        if (!this.$moreBtn) {
            return;
        }

        this.displayMoreBtn();

        this.$moreBtn.addEventListener('click', () => {
            this.get();
        });
    }

    async getTotal() {
        let url = this.getPaginationUrl(),
            data = await $.get(url);

        return data[0] ? parseInt(data[0].total, 10) : null;
    }

    async reset() {
        this.current = this.initial;
        this.total = await this.getTotal();
        this.displayMoreBtn();
    }

    get(isReset, isScroll = true) {
        if (isReset) {
            this.reset();
        }

        let url = this.getUrl(),
            querySeparator = url.indexOf('?') >= 0 ? '&' : '?';

        this.$list.classList.add('loader');

        $.get(`${url}${querySeparator}offset=${this.current}&items_per_page=${this.perPage}`)
            .done(data => {
                this.render(data, isReset, isScroll);
                this.$list.classList.remove('loader');
                this.$list.classList.remove('error');
            })
            .fail((error) => {
                console.warn(error);
                this.showMessage(this.errorTemplate);
                this.$list.classList.remove('loader');
                this.$list.classList.add('error');
            });
    }

    render(data, isReset, isScroll = true) {
        let count = data.length;

        if (count === 0) {
            this.showMessage(this.emptyTemplate);
            return;
        }

        if (this.current === this.initial) {
            this.$list.innerHTML = '';
        }

        for (let i = 0; i < count; i++) {
            this.renderSingle(data[i]);
        }

        let current = this.current - this.initial;
        if (!isReset && isScroll && this.$list.childNodes[current]) {
            setTimeout(() => {
                scrollWithOffset(this.$list.childNodes[current], null, document.getElementById('top-bar'))
                    .then(() => {
                        this.$list.childNodes[current].focus();
                    });
            }, 100);
        }

        this.current += count;

        if (this.$moreBtn && this.current >= this.total) {
            this.$moreBtn.style.display = 'none';
        }

        triggerEvent(this.$list, 'update');
    }

    renderSingle(data) {
        let $item = renderItem(data, this.itemTemplate),
            $emptyImgSource = $item ? $item.querySelectorAll('source[data-srcset=""]') : [];

        [...$emptyImgSource].forEach($el => $el.remove());
        this.$list.appendChild($item);
    }

    showMessage(template) {
        this.$list.innerHTML = '';
        this.$list.appendChild(getFromTemplate(template));
    }
}

export default ViewLoader;



// WEBPACK FOOTER //
// ./sources/js/components/view-loader.js